import CommonRequesterForm from '../Common/CommonRequesterForm';

const RequesterForm = ({ onSubmit, initialData, requesterData, ws }) => {
    // Use CommonRequesterForm with formType="postpaid"
    return (
        <CommonRequesterForm 
            formType="postpaid" 
            onSubmit={onSubmit}
            initialData={initialData}
            requesterData={requesterData}
            ws={ws}
        />
    );
};

export default RequesterForm;